import { t } from '../i18n'

/**
 * Экран загрузки (макет `Design_2/app_screens/Splash`).
 *
 * Показывается доли секунды, пока читается хранилище. Раньше на этом месте был пустой
 * тёмный прямоугольник: приложение выглядело так, будто не запустилось.
 */
export function Splash() {
  return (
    <div class="splash">
      <svg class="splash__sky" viewBox="0 0 390 844" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <defs>
          <radialGradient id="splash-glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stop-color="#F6C08F" stop-opacity="0.35" />
            <stop offset="1" stop-color="#F6C08F" stop-opacity="0" />
          </radialGradient>
          <radialGradient id="splash-moon" cx="0.4" cy="0.35" r="0.7">
            <stop offset="0" stop-color="#FFE3C4" />
            <stop offset="1" stop-color="#E9A86C" />
          </radialGradient>
        </defs>
        <g fill="#F2EEFA">
          {STARS.map(([cx, cy, r, o]) => (
            <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={r} opacity={o} />
          ))}
        </g>
        <circle cx="195" cy="380" r="170" fill="url(#splash-glow)" />
        <path d="M0 640 C 80 600, 140 620, 200 600 S 320 560, 390 590 L390 844 L0 844 Z" fill="#232150" />
        <path d="M0 690 C 90 660, 150 700, 230 670 S 330 640, 390 660 L390 844 L0 844 Z" fill="#1A1841" />
        <path d="M0 740 C 100 720, 180 760, 260 730 S 350 715, 390 725 L390 844 L0 844 Z" fill="#12112E" />
      </svg>

      <div class="splash__center">
        <svg class="splash__ring" viewBox="0 0 220 220" aria-hidden="true">
          <g fill="none" stroke-width="12" transform="rotate(-90 110 110)">
            <circle cx="110" cy="110" r="76" stroke="#F6C08F" stroke-dasharray="70 408" />
            <circle cx="110" cy="110" r="76" stroke="#9DC4EC" stroke-dasharray="58 420" stroke-dashoffset="-76" />
            <circle cx="110" cy="110" r="76" stroke="#A6DCC6" stroke-dasharray="142 336" stroke-dashoffset="-140" />
            <circle cx="110" cy="110" r="76" stroke="#C9B6F2" stroke-dasharray="104 374" stroke-dashoffset="-288" />
            <circle cx="110" cy="110" r="76" stroke="#F2A9B8" stroke-dasharray="74 404" stroke-dashoffset="-398" />
          </g>
          <path
            d="M 110.4 60.2 A 51.5 51.5 0 1 0 145.8 147 A 49.4 49.4 0 0 1 110.4 60.2 Z"
            fill="url(#splash-moon)"
          />
        </svg>

        <div class="splash__logo">
          <span>m</span>
          <svg viewBox="0 0 30 40" aria-hidden="true">
            <circle cx="15" cy="25" r="13" fill="#F6C08F" />
          </svg>
          <svg viewBox="0 0 30 40" aria-hidden="true">
            <circle cx="15" cy="25" r="13" fill="#F6C08F" />
            <circle cx="21" cy="21" r="12" fill="#1F1D44" />
          </svg>
          <span>nwake</span>
        </div>

        <span class="splash__tagline">{t('welcome_title')}</span>
      </div>

      <div class="splash__dots" role="status" aria-label={t('splash_loading')}>
        <span />
        <span />
        <span />
      </div>
    </div>
  )
}

/** Звёзды из макета: заданы явно, чтобы экран не мерцал по-разному при каждом запуске. */
const STARS: Array<[number, number, number, number]> = [
  [328, 281, 1.8, 0.75],
  [343, 49, 2.2, 0.74],
  [137, 73, 1.3, 0.41],
  [250, 272, 2.2, 0.62],
  [303, 275, 1, 0.72],
  [218, 306, 1.3, 0.81],
  [209, 183, 1, 0.42],
  [326, 475, 1.3, 0.42],
  [12, 234, 1.3, 0.83],
  [94, 190, 1.8, 0.51],
  [111, 229, 1.3, 0.82],
  [363, 221, 2.2, 0.5],
  [194, 444, 1.3, 0.82],
  [145, 86, 1.8, 0.5],
  [318, 23, 1.8, 0.38],
  [191, 333, 2.2, 0.7],
  [104, 512, 2.2, 0.7],
  [39, 282, 1, 0.82],
]
